import React, { useState } from "react";
import { sortTable } from "../utils/utils";

const AdminTable = ({ header, items, filter, row: Row, filterFunction }) => {
    const [loading, setLoading] = useState(false)

    const filteredPartnersList = () => {
        if (filter === '') return items
        else return items.filter(item => filterFunction(item, filter))
    }

    return (
        <div className="table-responsive">
            <table className="table table-striped table-sm" id="adminTable">
                <thead>
                    <tr>
                        {header?.map((col, i) => {
                            if (col !== '') return (
                                <th style={{ cursor: 'pointer' }} key={`header-${i}`} onClick={e => sortTable('adminTable', i)}>
                                    <i className="fa fa-fw fa-sort" />
                                    {col}
                                </th>
                            )
                            return (<th key={`header-${i}`}></th>)
                        }
                        )}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {filteredPartnersList()?.map((item, i) => (<Row key={`item-${i}`} data={item} />))}
                </tbody>
            </table>
            {/* {loading === true &&
                <div className="w-100 my-5 d-flex align-items-center justify-content-center">
                    <span className="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                </div>
            } */}
            {filteredPartnersList()?.length < 1 &&
                <div className="w-100 my-5 d-flex align-items-center justify-content-center">
                    <i className="fa fa-times me-4 fs-1" />
                    No existen resultados con estos parámetros
                </div>
            }
        </div>
    )
}

export default AdminTable;